var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.95 37.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 19.97,
    cy: 20.69,
    rx: 18.97,
    ry: 13.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.27,11.21S.59,4.05,6.35,1.49s8.32,5.86,8.32,5.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.29,11.88s5.46-6.82-.23-9.91-9.09,5.19-9.09,5.19"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11.95,
    cy: 21.08,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.95,
    cy: 21.08,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 27.95,
    cy: 21.08,
    r: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "4.95 28.5 4.95 36.08 12.25 33.01"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.cafef88a1d02cacc6c8b1561b0b9366a.svg";
export { ForwardRef as ReactComponent };